import { Route, mapToCanActivate } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { RouterFragments } from '@core/model/RouterFragments';
import { AccessPageGuard } from '@mynexus/mynexus-ui-lib';
import { authDetailsTitleResolver } from '@core/resolvers/auth-details-title.resolver';

export default [
  {
    path: `:tenantId/${RouterFragments.UNKNOWN}/home-health/auth-dashboard/:authorizationNumber`,
    loadChildren: () => import('@pages/auth-detail-not-found/auth-detail-not-found.module')
      .then((m) => m.AuthDetailNotFoundModule),
    title: 'Auth Details Not Found',
    canActivate: mapToCanActivate([MsalGuard]),
  },
  {
    path: ':tenantId/home-health/auth-dashboard/:authorizationNumber',
    loadChildren: () => import('@feature/auth-detail/auth-detail.module').then((m) => m.AuthDetailModule),
    title: authDetailsTitleResolver('Auth Details'),
    data: {
      permissions: ['AuthorizationPage.UI'],
    },
    canActivate: mapToCanActivate([MsalGuard, AccessPageGuard]),
  },
  {
    path: ':tenantId/home-health/auth-dashboard/:authorizationNumber/:authorizationDetailId',
    loadChildren: () =>import('@feature/auth-detail/auth-detail.module').then((m) => m.AuthDetailModule),
    title: authDetailsTitleResolver('Auth Detail'),
    data: {
      permissions: ['AuthorizationPage.UI'],
    },
    canActivate: mapToCanActivate([MsalGuard, AccessPageGuard]),
  },
  {
    path: ':tenantId/member/:memberId/home-health/request-initial',
    loadChildren: () => import('@feature/auth-request-initial/auth-request-initial.module')
      .then((m) => m.AuthRequestInitialModule),
    title: 'Authorization Request',
    data: {
      permissions: ['CreateAuthorizationPage.UI'],
    },
    canActivate: mapToCanActivate([MsalGuard]),
  },
  {
    path: ':tenantId/member/:memberId/home-health/request-subsequent/:authId',
    loadChildren: () => import('@feature/auth-request-subsequent/auth-request-subsequent.module')
      .then((m) => m.AuthRequestSubsequentModule),
    title: 'Request Visits',
    data: {
      permissions: ['CreateAuthorizationPage.UI'],
    },
    canActivate: mapToCanActivate([MsalGuard]),
  }
] as Route[];
